import { ArrowLeft, Building2 } from "lucide-react";
import { Button } from "./ui/button";

/**
 * Inline pill rendered in the ShopDashboard header — visible only when the
 * current shop session is delegated from a franchise owner (sessionStorage
 * flag set by /api/franchise/store-session/<shop_id>). Clicking restores
 * the owner's JWT and returns to /franchise/dashboard.
 *
 * Unlike the admin ImpersonationBanner which is a wide sticky strip
 * indicating read-only mode, this is a compact navigation affordance —
 * the franchise owner has full write access to their own store and the
 * dashboard otherwise looks identical to a regular single-shop dashboard.
 */
export default function FranchiseReturnLink() {
  const active = typeof window !== "undefined" && sessionStorage.getItem("franchise_session") === "true";
  if (!active) return null;
  const storeName = sessionStorage.getItem("franchise_store_name") || "store";

  const handleBack = () => {
    const ownerToken = sessionStorage.getItem("franchise_owner_token");
    sessionStorage.removeItem("franchise_session");
    sessionStorage.removeItem("franchise_store_name");
    sessionStorage.removeItem("franchise_owner_token");
    if (ownerToken) sessionStorage.setItem("token", ownerToken);
    // Defer past a tick — Safari sessionStorage write race fix.
    setTimeout(() => {
      window.location.assign("/franchise/dashboard");
    }, 0);
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleBack}
      className="gap-1.5 h-8 hidden md:inline-flex border-blue-500/40 text-blue-700 hover:bg-blue-50 dark:text-blue-300 dark:hover:bg-blue-950/30"
      data-testid="back-to-stores-btn"
      title={`Return to your franchise dashboard (${storeName})`}
    >
      <ArrowLeft className="h-3.5 w-3.5" />
      <span className="hidden lg:inline">Back to</span>
      <Building2 className="h-3.5 w-3.5" />
      <span>Manage Tyre Shops</span>
    </Button>
  );
}
